import { render, staticRenderFns } from "./TaskField.vue?vue&type=template&id=05432692&scoped=true"
import script from "./TaskField.vue?vue&type=script&lang=js"
export * from "./TaskField.vue?vue&type=script&lang=js"
import style0 from "./TaskField.vue?vue&type=style&index=0&id=05432692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05432692",
  null
  
)

export default component.exports